export const latestRecipes = [
  {
    title: "Gado Gado on Toast",
    img: "https://cdn.pickuplimes.com/cache/96/3b/963b4da712066e5d68a0413f8b9ffa53.jpg",
  },
  {
    title: "Gado Gado on Toast",
    img: "https://cdn.pickuplimes.com/cache/96/3b/963b4da712066e5d68a0413f8b9ffa53.jpg",
  },
  {
    title: "Gado Gado on Toast",
    img: "https://cdn.pickuplimes.com/cache/96/3b/963b4da712066e5d68a0413f8b9ffa53.jpg",
  },
  {
    title: "Gado Gado on Toast",
    img: "https://cdn.pickuplimes.com/cache/96/3b/963b4da712066e5d68a0413f8b9ffa53.jpg",
  },
  {
    title: "Gado Gado on Toast",
    img: "https://cdn.pickuplimes.com/cache/96/3b/963b4da712066e5d68a0413f8b9ffa53.jpg",
  },
  {
    title: "Gado Gado on Toast",
    img: "https://cdn.pickuplimes.com/cache/96/3b/963b4da712066e5d68a0413f8b9ffa53.jpg",
  },
];

export const latestVideos = [
  {
    title: "Sleep Better",
    text: 'with these evening snacks 😴',
    img: "https://cdn.pickuplimes.com/cache/86/be/86bed1c95e4bc945b17ee89afcb18ef0.jpg"
  },
  {
    title: "Plant-Based Meal Planning",
    text: "with the nourish method 🌈",
    img: "https://cdn.pickuplimes.com/cache/44/6b/446bfe07499576515a912ff7c435e077.jpg"
  },
  {
    title: "A Full Day of Easy At-Home Meals 🍜",
    text: '',
    img: "https://cdn.pickuplimes.com/cache/a8/7b/a87befa622aec1df673c64359d589101.jpg"
  },
  {
    title: "Days in the Life",
    text: "home alone, it's just you and me 😉t",
    img: "https://cdn.pickuplimes.com/cache/fd/81/fd8131160fc7fd669ed90be9b1473ca6.jpg"
  },
  {
    title: "Quick Meals When You Don’t Feel Like Cooking",
    text: " 15 minutes, 8 ingredients",
    img: "https://cdn.pickuplimes.com/cache/12/3c/123ccdd37f513dc49e4330608396cdde.jpg"
  },
  {
    title: "The True Meaning of Life",
    text: " existence is weird 🪐",
    img: "https://cdn.pickuplimes.com/cache/d7/0e/d70e4c577057f2eddad15b018860ba72.jpg"
  }
]


export const latestArticles = [
  {
    image: 'https://cdn.pickuplimes.com/cache/b1/79/b179362aaf19279b1b92e2844886cc8b.jpg',
    heading: 'The Nourish Method',
    subheading: 'plant-based eating made easy (+ complete)'
  },
  {
    image: 'https://cdn.pickuplimes.com/cache/b1/79/b179362aaf19279b1b92e2844886cc8b.jpg',
    heading: 'The Nourish Method',
    subheading: 'plant-based eating made easy (+ complete)'
  },
  {
    image: 'https://cdn.pickuplimes.com/cache/b1/79/b179362aaf19279b1b92e2844886cc8b.jpg',
    heading: 'The Nourish Method',
    subheading: 'plant-based eating made easy (+ complete)'
  },
  {
    image: 'https://cdn.pickuplimes.com/cache/b1/79/b179362aaf19279b1b92e2844886cc8b.jpg',
    heading: 'The Nourish Method',
    subheading: 'plant-based eating made easy (+ complete)'
  },
  {
    image: 'https://cdn.pickuplimes.com/cache/b1/79/b179362aaf19279b1b92e2844886cc8b.jpg',
    heading: 'The Nourish Method',
    subheading: 'plant-based eating made easy (+ complete)'
  },
  {
    image: 'https://cdn.pickuplimes.com/cache/b1/79/b179362aaf19279b1b92e2844886cc8b.jpg',
    heading: 'The Nourish Method',
    subheading: 'plant-based eating made easy (+ complete)'
  }
]


